export function calculateStandardDeviation(arr: number[]): number {
  let sum = 0;
  const diffSquaredArray = [];

  if (arr.length === 0) {
    return sum;
  }

  for (let i = 0; i < arr.length; i += 1) {
    sum += arr[i];
  }

  const mean = sum / arr.length;

  for (let j = 0; j < arr.length; j += 1) {
    diffSquaredArray.push(Math.pow(arr[j] - mean, 2));
  }

  return Math.sqrt(diffSquaredArray.reduce((first, next) => first + next) / arr.length);
}

export function calculateAverage(arr: number[]): number {
  let sum = 0;

  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
  }

  return sum / arr.length;
}
